export const FINANCIAL_JOURNAL_VIEW = "/finance"
export const FINANCE_TRANSACTION_LIST_VIEW =
  FINANCIAL_JOURNAL_VIEW + "/transactions"
export const NEW_TRANSACTION_VIEW = FINANCE_TRANSACTION_LIST_VIEW + "/new"
export const FINANCE_TRANSACTIONS_HISTORY_VIEW =
  FINANCE_TRANSACTION_LIST_VIEW + "/history"
